import { render, staticRenderFns } from "./SectionContainer.vue?vue&type=template&id=3148359c&scoped=true&"
import script from "./SectionContainer.vue?vue&type=script&lang=js&"
export * from "./SectionContainer.vue?vue&type=script&lang=js&"
import style0 from "./SectionContainer.vue?vue&type=style&index=0&id=3148359c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3148359c",
  null
  
)

export default component.exports